'use client';

import { InverseHeader, RadialGradientBG } from '@jouzen/ecom-components';
import { redirect } from 'next/navigation';
import { useGate } from 'statsig-react';

import PageLayoutV3 from '@/app/components/PageLayoutV3';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import HeartHealthFeatures from './_components/HeartHealthFeatures';
import HeartHealthHero from './_components/HeartHealthHero';
import HeartHealthIntegrations from './_components/HeartHealthIntegrations';
import HeartHealthJumbotron from './_components/HeartHealthJumbotron';
import HeartHealthPress from './_components/HeartHealthPress';
import HeartHealthTestimonials from './_components/HeartHealthTestimonials';
import heartHealthTestimonialsGradients from './_data/heartHealthTestimonialsGradients';

const Content = (): JSX.Element => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  const heartHealthPageEnabled = useGate('heart_health_page_rollout').value;

  if (!heartHealthPageEnabled) {
    return redirect('/404');
  }

  return (
    <PageLayoutV3
      pageName="Heart Health"
      containerProps={{
        className: 'bg-sandstone-200',
        name: 'heart-health',
        padding: 'none',
      }}
      footerProps={{
        inverseHeaderOnScrollUp: true,
        wrapperClassName: 'bg-brown-500',
      }}
    >
      <InverseHeader exit>
        <HeartHealthHero />
        <RadialGradientBG
          background="sandstone-200"
          className="overflow-hidden"
          gradients={heartHealthTestimonialsGradients}
        >
          <HeartHealthFeatures />
          <HeartHealthJumbotron />
          <HeartHealthTestimonials />
          <HeartHealthIntegrations />
        </RadialGradientBG>
      </InverseHeader>
      <InverseHeader enter>
        <HeartHealthPress />
      </InverseHeader>
    </PageLayoutV3>
  );
};

export default Content;
